import { HttpClient } from '@angular/common/http';
import {
    TRANSLOCO_LOADER,
    Translation,
    TranslocoLoader,
    TranslocoModule,
    provideTransloco,
} from '@jsverse/transloco';
import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { customFallbackStrategy } from './fallback-strategy';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private readonly http: HttpClient) { }

    public getTranslation(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`./assets/i18n/${lang}.json`);
    }

}

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: ['de'],
                defaultLang: 'de',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                prodMode: environment.production,
            },
            loader: TranslocoHttpLoader
        }),
        customFallbackStrategy,


        { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    ],
})
export class TranslocoRootModule { }
